import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import Newsletter from "./Newsletter";

const COLS = [
  ["Read", [["Latest", "/articles"], ["Peer-reviewed research", "/articles?type=research"], ["Business analysis", "/articles?type=news"], ["Magazine archive", "/issues"], ["Online reader", "/reader/v14n4"]]],
  ["BPJ", [["Subscribe", "/subscribe"], ["Store", "/shop"], ["Coaching", "/coaching"], ["Submit a manuscript", "/submit"], ["Contact the editors", "/contact"], ["Editors' login", "/admin"]]],
];

export default function Footer() {
  return (
    <footer className="bg-[#0D1B3E] text-white mt-32 relative grain" data-testid="site-footer">
      <div className="px-5 lg:px-12 pt-20 pb-10 grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo invert size="lg" />
          <h3 className="f-serif text-3xl sm:text-4xl mt-10 leading-tight">The Monday Briefing.<br /><em className="text-[#E0E0E0]">One idea worth your week.</em></h3>
          <div className="mt-8 max-w-md"><Newsletter dark /></div>
        </div>
        {COLS.map(([t, links]) => (
          <div key={t} className="lg:col-span-2 lg:col-start-auto">
            <p className="eyebrow !text-[#A8A8A8] mb-5">{t}</p>
            <ul className="space-y-3 text-[0.95rem] text-[#E6E6E6]">
              {links.map(([l, h]) => <li key={l}><Link to={h} className="link-u">{l}</Link></li>)}
            </ul>
          </div>
        ))}
        <div className="lg:col-span-3">
          <p className="eyebrow !text-[#A8A8A8] mb-5">Indexing</p>
          <p className="text-[#D4D4D4] text-sm leading-relaxed">ISSN [placeholder] · DOI prefix [placeholder]. Indexing details to be confirmed by the editorial office.</p>
        </div>
      </div>
      <div className="overflow-hidden px-5 lg:px-12">
        <p className="f-serif text-[22vw] leading-[0.8] tracking-tighter text-white/[0.06] select-none -mb-[3vw]" aria-hidden="true">BPJ</p>
      </div>
      <div className="px-5 lg:px-12 pt-6 pb-24 sm:pb-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#A8A8A8] f-mono">
        <span>© 2026 Business Performance Journal · b-p-j.net</span>
        <span>Ethics & peer-review policy · Privacy · Terms</span>
      </div>
    </footer>
  );
}
